import moment from 'moment'

export const formatRawDate = (date: string | Date, toFormat: string = 'YYYY') =>
  moment(date).format(toFormat)

export const formatRawDateFull = (
  date?: string | Date,
  toFormat: string = 'YYYY-MM-DD',
) => (date ? moment(date).format(toFormat) : '')

export const formatRawDateOffset = (
  date: string,
  toFormat: string = 'YYYY/MM/DD',
) =>
  moment
    .utc(date)
    .utcOffset(Math.abs(Math.floor(new Date().getTimezoneOffset() / 60)))
    .format(toFormat)
